import { Product } from "@/types"

interface FabricConfig {
  name: string
  rollLength: number
  minCutLength: number
  maxCutLength: number
}

const FABRIC_CONFIGS: FabricConfig[] = [
  {
    name: "Vertical Fabric",
    rollLength: 100,
    minCutLength: 20,
    maxCutLength: 80,
  },
  {
    name: "Vertical Fabric",
    rollLength: 50,
    minCutLength: 10,
    maxCutLength: 40,
  },
  {
    name: "Roller Fabric",
    rollLength: 20,
    minCutLength: 1,
    maxCutLength: 18,
  },
  {
    name: "Allusion Fabric",
    rollLength: 55,
    minCutLength: 10,
    maxCutLength: 40,
  },
  {
    name: "Cellular Fabric",
    rollLength: 20,
    minCutLength: 1,
    maxCutLength: 18,
  },
  {
    name: "Pleated Fabric",
    rollLength: 25,
    minCutLength: 1,
    maxCutLength: 23,
  },
  {
    name: "Vision Fabric",
    rollLength: 50,
    minCutLength: 1,
    maxCutLength: 48,
  },
  {
    name: "Vision Fabric",
    rollLength: 40,
    minCutLength: 1,
    maxCutLength: 38,
  },
  {
    name: "Vision Fabric",
    rollLength: 30,
    minCutLength: 1,
    maxCutLength: 28,
  },
]

export const getFabricConfig = (product: Product) =>
  FABRIC_CONFIGS.find(
    (config) =>
      product.sub_categories?.some((item) => item.name === config.name) &&
      product.roll_length === config.rollLength,
  )

const DescriptionFabrics = ({ product }: { product: Product }) => {
  const data = getFabricConfig(product)

  // If no specific config found, use default values
  const { rollLength = 20, minCutLength = 1, maxCutLength = 18 } = data || {}

  return (
    <p>
      Enter the total metreage required. This can be a full {rollLength}m roll,
      a cut length from {minCutLength}m to {maxCutLength}m, or a combination of
      both.
    </p>
  )
}

export default DescriptionFabrics
